module.exports = __webpack_public_path__ + "img/2020nh.c918309d.jpg";